import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import moment from 'moment';
import { LOCAL_STORAGE_KEY, nyushoGridConfig, SAUCER_LOG_ACTION, SCREEN_NAME, SESSION_STORAGE_KEY, tsushoGridConfig } from '@core/configs';
import { bathingGridConfig } from '@core/configs/bathing-header.config';
import { BATHINGDIALOG, BathingScreenSortType, ButtonType, CHECKSHEETSETTINGDIALOG, DpadZoneType, ExcreationSortType, Mode, TV, USERDASHBOARDDIALOG, UserSettingMenu } from '@core/constants';
import { Utils } from '@core/helper';
import { CheckSheetSettingHelper } from '@core/helper/check-sheet-setting.helper';
import { buildHeaderLogItems } from '@core/helper/saucer-log.helper';
import { CheckSheetDisplayOrder, InputType, SortType } from '@core/models/enums';
import { DropdownOption, ExcreationConfigModel, InputParams, NyuShoDisplayConfigModel, SettingConfigModel } from '@core/models/models';
import { DeviceLicensesService } from '@core/services/apis';
import { DeviceInfo, EMPTY_DEVICE_INFO } from '@core/services/apis/device-licenses.service';
import { SessionStorageService, CommonHelper, BathingScreenService, LocalStorageService, SessionContextService, TvDisplaySettingsResetService, TvMenuRefreshService, MarqueeSpeedService } from '@core/services/common';
import { MultipleSpinnerService } from '@core/services/common/multiple-spinner.service';
import { DpadControlService } from '@core/services/common/dpad-control.service';
import { FirebaseDeviceInfoService } from '@core/services/common/firebase/firebase-device-info.service';
import { SaucerLogService } from '@core/services/saucer-logs/saucer-log.service';
import { LayoutConfig } from '@modules/bathing-schedule/bathing-monitor.setting.model';
import { UserDashboardSreenSetting } from '@modules/user-dashboard/user-dashboard-setting-dialog/user-dashboard-setting.model';
import { Subscription } from 'rxjs';
import { getCheckSheetSetting } from './check-sheet-tv-setting.helper';
import {
    getFunctionalTrainingDefaultConfig,
    getFunctionalTrainingHeaders as getFunctionalTrainingSettingHeaders,
    getFunctionalTrainingSetting,
    prepareFunctionalTrainingSettingForStorage,
} from './functional-training-tv-setting.helper';
import {
    getShortTimeDefaultConfig,
    getShortTimeHeaders as getShortTimeSettingHeaders,
    getShortTimeSetting,
    prepareShortTimeSettingForStorage,
} from './short-time-tv-setting.helper';

const DEFAULT_VERSION = '0.0.0';
const DEVICE_NAME_MAX_LENGTH = 9;
const DEVICE_NAME_INPUT_ID = 'tv-device-name-input';
const LOGIN_DATE_FORMAT = 'YYYY年M月D日HH:mm';

@Component({
  selector: 'caremoni-user-setting-menu-right',
  templateUrl: './user-setting-menu-right.component.html',
  styleUrl: './user-setting-menu-right.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class UserSettingMenuRightComponent implements OnInit, OnDestroy {
    @Input() headers: any[] = [];
    @Input() midMenuId: number = 0;
    @Input() isShowRightMenu: boolean = true;
    @Output() deviceNameChange = new EventEmitter<string>();

    private _leftMenuName: string = '';

    @Input()
    set leftMenuName(value: string) {
        if (this._leftMenuName === value) return;
        this._leftMenuName = value;

        if (this.isInitialized) {
            void this.loadSettingForCurrentMenu();
        }
    }

    get leftMenuName(): string {
        return this._leftMenuName;
    }

    subscription: Subscription = new Subscription();

    DpadZoneType = DpadZoneType;
    UserSettingMenu = UserSettingMenu;
    ButtonType = ButtonType;
    TV = TV;
    CHECKSHEETSETTINGDIALOG = CHECKSHEETSETTINGDIALOG;
    USERDASHBOARDDIALOG = USERDASHBOARDDIALOG;
    BATHINGDIALOG = BATHINGDIALOG;
    isSortByRoom: boolean = true;
    isSortByName: boolean = false;
    timeRanges: any[] = [6, 5, 4, 3, 2, 1];
    timeRangeSelected: number = 6;
    marginToTimes: any[] = [0, 5, 10, 15, 30, 45, 60];
    marginToTimeSelected: number = 30;
    isNyuSho: boolean = true;
    currentHeaders: any[] = [];
    get gridColumns(): string {
        // Cố định 4 hàng, cột tự động
        let numCols = Math.ceil(this.currentHeaders.length / 2);
        return `repeat(${numCols}, 1fr)`;
    }
    timeChangePage: number = 30;
    inputParams: InputParams = {
        type: InputType.number,
        validate: false,
        readonly: false,
        disabled: false,
        maxLength: 100,
        borderFill: false,
        tabindex: 20
    };
    isFlashingMoshiokuri: boolean = false;
    displayUnits: any[] = [];
    unitSelected: string[] = [];
    displayGroups: any[] = [];
    groupSelected: string[] = [];
    displayBathRooms: any[] = [];
    bathRoomSelected: string = "";

    sessionGroupData: DropdownOption[] = [];
    sessionBathRoomData: DropdownOption[] = [];
    marqueeSpeedOptions: DropdownOption[] = [];
    marqueeSpeedRate: string = '';
    settingCShDialog: any;
    userDBSettings: UserDashboardSreenSetting = new UserDashboardSreenSetting();
    batheSettings: LayoutConfig = new LayoutConfig();
    currentBathHeaders:any[] = [];

    BATHE_SORT_TYPE = BathingScreenSortType;
    EXCREATION_SORT_TYPE = ExcreationSortType;

    private readonly minuteInMs: number = 1000;
    private isInitialized: boolean = false;

    inputFieldSettings: InputParams = {
        type: InputType.number,
        validate: false,
        readonly: false,
        disabled: false,
        maxLength: 100,
        borderFill: false,
        tabindex: 20
    };

    deviceName: string = '';
    DEVICE_NAME_INPUT_ID = DEVICE_NAME_INPUT_ID;
    private savedDeviceName: string = '';
    private savingDeviceName: string = '';
    appVersion: string = DEFAULT_VERSION;
    webViewVersion: string = DEFAULT_VERSION;
    loginOfficeName: string = '';
    loginStaffName: string = '';
    lastLoginDate: string = '';
    deviceNameInputParams: InputParams = {
        type: InputType.text,
        validate: false,
        readonly: false,
        disabled: false,
        maxLength: DEVICE_NAME_MAX_LENGTH,
        borderFill: false,
        tabindex: 20
    };

    constructor(
        private dpadControlService: DpadControlService,
        private sessionStorageService: SessionStorageService,
        private sessionContextService: SessionContextService,
        private checkSheetSettingHelper: CheckSheetSettingHelper,
        private bathingScreenService: BathingScreenService,
        private localStorageService: LocalStorageService,
        private marqueeSpeedService: MarqueeSpeedService,
        private cdr: ChangeDetectorRef,
        private deviceLicensesService: DeviceLicensesService,
        private tvDisplaySettingsResetService: TvDisplaySettingsResetService,
        private firebaseDeviceInfoService: FirebaseDeviceInfoService,
        private mutiLoadingService: MultipleSpinnerService,
        private tvMenuRefreshService: TvMenuRefreshService,
        private saucerLogService: SaucerLogService,
    ) {
        let officeSelected = this.sessionContextService.getOfficeSelected<any>();
        this.isNyuSho = Utils.isNyusho(officeSelected.officeType);
    }

    async ngOnInit(): Promise<void>{
        this.subscription.add(
            this.tvDisplaySettingsResetService.reset$.subscribe(() => {
                void this.reloadSettingsAfterRemoteReset(); // recevice event load setting to be default
            }),
        );

        this.marqueeSpeedOptions = this.marqueeSpeedService.getSpeedOptions();
        this.marqueeSpeedRate = `${this.marqueeSpeedService.getSpeedRate()}`;
        this.displayGroups = await this.checkSheetSettingHelper.getGroupInfo();
        this.displayUnits = await this.checkSheetSettingHelper.getBlockAndUnitInfo();
        const deviceInfo = await this.loadDeviceInfo();
        this.deviceName = deviceInfo.deviceName;
        this.savedDeviceName = this.deviceName;
        if (this.deviceName) this.deviceNameChange.emit(this.deviceName);
        this.appVersion = this.firebaseDeviceInfoService.getAppVersion() || DEFAULT_VERSION;
        this.webViewVersion = deviceInfo.webViewVersion || DEFAULT_VERSION;
        this.loadLoginInfo();
        // Fetch bathroom data first, then generate dropdown options
        await this.fetchBathRoomData();
    }

    private loadLoginInfo(): void {
        const staffInfo = this.sessionContextService.getStaffInfo<any>();
        this.loginOfficeName = this.sessionContextService.getOfficeSelected<any>()?.officeNm || '';
        this.loginStaffName = [staffInfo?.family, staffInfo?.given].filter(Boolean).join(' ');
        const loginDateTime = this.sessionStorageService.getSessionData<string>(SESSION_STORAGE_KEY.loginDateTime);
        this.lastLoginDate = loginDateTime ? moment(loginDateTime).format(LOGIN_DATE_FORMAT) : '';
    }

    private async loadDeviceInfo(): Promise<DeviceInfo> {
        const deviceId = this.firebaseDeviceInfoService.getAndroidDeviceId();
        if (!deviceId) return EMPTY_DEVICE_INFO;

        return await this.deviceLicensesService.getDeviceInfoByDeviceId(deviceId);
    }

    async fetchBathRoomData() {
        await this.bathingScreenService.getBathroomInfos();
        const bathRoomListSession = this.bathingScreenService.genBathRoomSelectOptions();
        this.displayBathRooms = bathRoomListSession;
        this.sessionBathRoomData = bathRoomListSession;
        await this.loadSettingForCurrentMenu();
        this.isInitialized = true;
    }

    private async loadSettingForCurrentMenu(): Promise<void> {
        this.getSetting();
        this.displayGroups = await this.handleGroupByUnit();
        this.displayBathRooms = await this.handleBathRoomByUnit();
        this.ensureSettingConfig();
    }

    private async reloadSettingsAfterRemoteReset(): Promise<void> {
        try {
            await this.loadSettingForCurrentMenu();
            this.cdr.detectChanges();
        } catch (error) {
            console.error('Failed to reload TV settings after remote reset:', error);
        }
    }

    private ensureSettingConfig(): void {
        if (!this.settingCShDialog) return;

        if (this.settingCShDialog && !this.settingCShDialog?.bathingScreenConfig) {
            this.settingCShDialog.bathingScreenConfig = this.batheSettings;
        }
        if (!this.isNyuSho && this.leftMenuName === 'bathe' && !this.settingCShDialog?.sortConfig) { //ensure has sort config in setting when select bath setting
            const bathingScreenConfig = this.settingCShDialog?.bathingScreenConfig;
            this.settingCShDialog.sortConfig = {
                ...this.getDefaultSortConfig(),
                unitSelected: bathingScreenConfig?.unitSelectedKey ?? this.unitSelected ?? [],
                groupSelected: bathingScreenConfig?.groupSelectedKey ?? this.groupSelected ?? [],
            };
        }
        if (this.settingCShDialog && !this.settingCShDialog?.excreationConfig) {
            this.settingCShDialog.excreationConfig = new ExcreationConfigModel();
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        // save pending device name when leaving the screen
        void this.saveDeviceName(this.deviceName);
    }
    
    onChangeBatheHeaderColumns(header: any) {
        const oldHeaders = buildHeaderLogItems(this.currentBathHeaders);
        header.visible = !header.visible;
        this.batheSettings.displayColumnAliases = this.currentBathHeaders.filter(e => e.visible).map(e => e.field);
        this.settingCShDialog.bathingScreenConfig = this.batheSettings
        this.saveSessionConfig(this.settingCShDialog);
        this.logSaucerLogUpdate(
            { headers: oldHeaders },
            { headers: buildHeaderLogItems(this.currentBathHeaders) }
        );
    }

    async handleGroupByUnit() {
        this.sessionGroupData = this.sessionStorageService.getSessionData(LOCAL_STORAGE_KEY.groupData) || [];
        if (!Array.isArray(this.unitSelected)) {
            if (this.unitSelected) {
                this.unitSelected = [this.unitSelected];
            } else {
                this.unitSelected = [];
            }
        }
        const groups = await this.checkSheetSettingHelper.filterGroupByUnit(this.unitSelected, this.sessionGroupData) || [];
        if (!Array.isArray(this.groupSelected)) {
            if (this.groupSelected) {
                this.groupSelected = [this.groupSelected];
            } else {
                this.groupSelected = [];
            }
        }
        return groups;
    }

    async handleBathRoomByUnit() {
        const bathRooms = await this.checkSheetSettingHelper.filterBathRoomByUnit(this.unitSelected, this.sessionBathRoomData) || [];
        return bathRooms;
    }



    // lấy data setting lưu từ local Storage
    get isShortTimeSettingMenu(): boolean {
        return this.leftMenuName === 'checksheet-shorttime';
    }

    private get isFunctionalTrainingSettingMenu(): boolean {
        return this.leftMenuName === 'checksheet-ft-training';
    }

    private getSettingForSelectedLeftMenu(settingData: any): any {
        if (!settingData) return null;

        switch (this.leftMenuName) {
            case 'checksheet-ft-training':
                return getFunctionalTrainingSetting(settingData, (header: any) => this.prepareDefaultSettingHeader(header));
            case 'checksheet-shorttime':
                return getShortTimeSetting(settingData, (header: any) => this.prepareDefaultSettingHeader(header));
            case 'checksheet':
                return getCheckSheetSetting(settingData, {
                    isNyuSho: this.isNyuSho,
                    defaultNyuShoDisplayConfig: this.getDefaultNyuShoDisplayConfig(),
                    defaultSortConfig: this.getDefaultSortConfig(),
                    prepareHeader: (header: any) => this.prepareDefaultSettingHeader(header),
                });
            default:
                return settingData;
        }
    }

        addDefaultConfig(){
        // Set default config.
        let settingDialog: any = {
            headers: this.currentHeaders,
            timeChangePage: 30,
            bathingScreenConfig: new LayoutConfig(),
            excreationConfig: new ExcreationConfigModel(),
            userDashboardSettings: new UserDashboardSreenSetting(),
            isFlashingMoshiokuri: this.isFlashingMoshiokuri,
            ...(this.isNyuSho
                ? { nyuShoDisplayConfig: new NyuShoDisplayConfigModel() }
                : { sortConfig: new SettingConfigModel() })
        };

        if (this.isFunctionalTrainingSettingMenu) {
            const nyuShoDisplayConfig = getFunctionalTrainingDefaultConfig();
            settingDialog = {
                ...settingDialog,
                nyuShoDisplayConfig,
                sortConfig: nyuShoDisplayConfig,
            };
        } else if (this.isShortTimeSettingMenu || (this.leftMenuName === 'checksheet' && !this.isNyuSho)) {
            settingDialog =  {
                ...settingDialog,
                sortConfig: this.isShortTimeSettingMenu
                    ? getShortTimeDefaultConfig()
                    : this.getDefaultSortConfig(),
            };
        }
        else (this.leftMenuName == 'checksheet')
        {
            settingDialog= 
                {  ...settingDialog,
                    nyuShoDisplayConfig: this.getDefaultNyuShoDisplayConfig(),
                };
        }

        this.settingCShDialog = settingDialog;
        this.saveSessionConfig(settingDialog);
    }

    private prepareSelectedLeftMenuSettingForStorage(config: any): any {
        switch (this.leftMenuName) {
            case 'checksheet-ft-training':
                return prepareFunctionalTrainingSettingForStorage(config);
            case 'checksheet-shorttime':
                return prepareShortTimeSettingForStorage(config);
            default:
                return config;
        }
    }

    private getShortTimeHeaders(headers: any[]): any[] {
        return getShortTimeSettingHeaders(headers, (header: any) => this.prepareDefaultSettingHeader(header));
    }

    private getFunctionalTrainingHeaders(headers: any[]): any[] {
        return getFunctionalTrainingSettingHeaders(headers, (header: any) => this.prepareDefaultSettingHeader(header));
    }

    private prepareDefaultSettingHeader(header: any): any {
        const defaultHeader = {
            ...header,
            title: header.title ?? header.items,
            displayLbl: header.displayLbl ?? this.getHeaderDisplayText(header),
            visible: header.visible ?? true,
        };
        return defaultHeader;
    }

    private getHeaderDisplayText(header: any): string {
        if (!Array.isArray(header?.items) || header.items.length === 0) return header?.displayLbl ?? '';
        if (header.isSplitCell) return header.items.map((item: any) => item.title).join(' ');
        return header.items[0]?.title ?? '';
    }

    async getSetting() {
        const savedSetting = this.getStoredScreenConfig();
        this.settingCShDialog = this.getSettingForSelectedLeftMenu(savedSetting); //Adjusts the saved data based on selected left menu.

        if (!this.settingCShDialog) {
            this.currentHeaders = this.getDefaultCurrentHeaders();
            this.isFlashingMoshiokuri = true;
            await this.addDefaultConfig();
            // this.settingCShDialog = this.buildDefaultSetting();
        }
        else {
            this.currentHeaders = this.getCurrentHeaders(this.settingCShDialog.headers);

            this.timeChangePage = this.settingCShDialog.timeChangePage;
            this.isFlashingMoshiokuri = this.settingCShDialog?.isFlashingMoshiokuri ?? true;
            if (this.isNyuSho) {
                this.timeRangeSelected = this.settingCShDialog?.nyuShoDisplayConfig?.timeRangeSelected;
                this.marginToTimeSelected = this.settingCShDialog?.nyuShoDisplayConfig?.marginToTimeSelected;
                this.unitSelected = this.settingCShDialog?.nyuShoDisplayConfig?.unitSelected;
                this.groupSelected = this.settingCShDialog?.nyuShoDisplayConfig?.groupSelected;
                this.isSortByName = this.settingCShDialog?.nyuShoDisplayConfig?.isSortByName;
                this.isSortByRoom = this.settingCShDialog?.nyuShoDisplayConfig?.isSortByRoom;
                // UserDashBoard settings
                this.userDBSettings = this.settingCShDialog?.userDashboardSettings || new UserDashboardSreenSetting();
            } else {
                if (this.settingCShDialog?.sortConfig) {
                    this.unitSelected = this.settingCShDialog?.sortConfig?.unitSelected;
                    this.groupSelected = this.settingCShDialog?.sortConfig?.groupSelected;
                }
            }
           
        }
        this.handlerBatheSetting();
    }

    private getStoredScreenConfig(): any {
        try {
            return CommonHelper.getScreenConfigByOfficeCd();
        } catch (error) {
            return null;
        }
    }

    private getDefaultCurrentHeaders(): any[] {
        const headers = this.getDefaultHeadersForCurrentMenu()
            ?.filter((header: any) => header?.field !== 'index')
            .map((header: any) => ({
                ...header,
                title: header.title ?? header.items,
                visible: header.visible ?? true,
            })) ?? [];

        return this.getCurrentHeaders(headers);
    }

    private getDefaultHeadersForCurrentMenu(): any[] {
        switch (this.leftMenuName) {
            case 'checksheet-shorttime':
                return this.getShortTimeHeaders([]);
            case 'checksheet-ft-training':
                return this.getFunctionalTrainingHeaders([]);
            default:
                return this.isNyuSho ? nyushoGridConfig.header : tsushoGridConfig.header;
        }
    }

    private getCurrentHeaders(headers: any[]): any[] {
        return this.isNyuSho
            ? this.checkSheetSettingHelper.handleHeaderColMoiSture(headers)
            : this.checkSheetSettingHelper.processReasonLeaveColumn(headers);
    }

    // private buildDefaultSetting(): any {
    //     const defaultSetting = {
    //         headers: this.currentHeaders,
    //         timeChangePage: this.timeChangePage,
    //         isFlashingMoshiokuri: true,
    //         userDashboardSettings: this.userDBSettings,
    //         bathingScreenConfig: this.batheSettings,
    //         excreationConfig: new ExcreationConfigModel(),
    //     };

    //     if (this.isFunctionalTrainingSettingMenu) {
    //         const nyuShoDisplayConfig = getFunctionalTrainingDefaultConfig();
    //         return {
    //             ...defaultSetting,
    //             nyuShoDisplayConfig,
    //             sortConfig: nyuShoDisplayConfig,
    //         };
    //     }

    //     if (this.isShortTimeSettingMenu || (this.leftMenuName === 'checksheet' && !this.isNyuSho)) {
    //         return {
    //             ...defaultSetting,
    //             sortConfig: this.isShortTimeSettingMenu
    //                 ? getShortTimeDefaultConfig()
    //                 : this.getDefaultSortConfig(),
    //         };
    //     }

    //     if (this.leftMenuName !== 'checksheet') return defaultSetting;

    //     return {
    //         ...defaultSetting,
    //         nyuShoDisplayConfig: this.getDefaultNyuShoDisplayConfig(),
    //     };
    // }

    private getDefaultNyuShoDisplayConfig(): any {
        return {
            isSortByRoom: this.isSortByRoom,
            isSortByName: this.isSortByName,
            timeRangeSelected: this.timeRangeSelected,
            marginToTimeSelected: this.marginToTimeSelected,
            unitSelected: this.unitSelected,
            groupSelected: this.groupSelected
        };
    }

    private getDefaultSortConfig(): any {
        return {
            unitSelected: this.unitSelected,
            groupSelected: this.groupSelected,
            hidden_overtime_flg: false,
            hidden_leave_user: false,
        };
    }



    onExcreationRadioClick(type: ExcreationSortType){
        if(this.settingCShDialog?.excreationConfig){
            const oldValue = this.settingCShDialog.excreationConfig.sortType;
            this.settingCShDialog.excreationConfig.sortType = type;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { sortType: oldValue },
                { sortType: type }
            );
        }
    }

    handlerBatheSetting(){
        this.batheSettings = this.settingCShDialog?.bathingScreenConfig ?? new LayoutConfig();

        // clone header để tránh mutate config gốc
        this.currentBathHeaders = bathingGridConfig.header;

        this.bathRoomSelected = this.batheSettings.bathRoomSelectedKey;

        const aliases = this.batheSettings.displayColumnAliases ?? [];

        // Nếu không có config -> dùng visible mặc định trong grid config
        if (!aliases.length) {
            return;
        }

        // Nếu có config -> set visible theo aliases
        this.currentBathHeaders = this.currentBathHeaders.map(h => ({
            ...h,
            visible:(h.field === "index" || h.field === "priority") ? true : aliases.includes(h.field)
        }));
    }

    onNyuShoRadioClick(event: any){
        const oldNyuShoSort = this.settingCShDialog?.nyuShoDisplayConfig
            ? {
                isSortByName: this.settingCShDialog.nyuShoDisplayConfig.isSortByName,
                isSortByRoom: this.settingCShDialog.nyuShoDisplayConfig.isSortByRoom
            }
            : null;
        if(event == 'sortRoom'){
            this.isSortByRoom = true;
            this.isSortByName = false;
        }
        else if(event == 'sortName'){
            this.isSortByRoom = false;
            this.isSortByName = true;
        }
        if(this.settingCShDialog?.nyuShoDisplayConfig){
            this.settingCShDialog.nyuShoDisplayConfig.isSortByName = this.isSortByName;
            this.settingCShDialog.nyuShoDisplayConfig.isSortByRoom = this.isSortByRoom;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                oldNyuShoSort,
                {
                    isSortByName: this.isSortByName,
                    isSortByRoom: this.isSortByRoom
                }
            );
        }
    }

    onShortTimeDisplayOrderClick(order: CheckSheetDisplayOrder): void {
        if (!this.settingCShDialog?.sortConfig) return;
        const oldSortConfig = {
            display_order: this.settingCShDialog.sortConfig.display_order,
            time_grouping_flg: this.settingCShDialog.sortConfig.time_grouping_flg,
            sorting_time: this.settingCShDialog.sortConfig.sorting_time
        };
        this.settingCShDialog.sortConfig.display_order = order;
        this.settingCShDialog.sortConfig.time_grouping_flg = order !== CheckSheetDisplayOrder.Name;
        this.settingCShDialog.sortConfig.sorting_time = order === CheckSheetDisplayOrder.EndTime
            ? CheckSheetDisplayOrder.EndTime
            : CheckSheetDisplayOrder.StartTime;
        this.saveSessionConfig(this.settingCShDialog);
        this.logSaucerLogUpdate(oldSortConfig, {
            display_order: this.settingCShDialog.sortConfig.display_order,
            time_grouping_flg: this.settingCShDialog.sortConfig.time_grouping_flg,
            sorting_time: this.settingCShDialog.sortConfig.sorting_time
        });
    }

    bathScreenRadioClick(type: BathingScreenSortType){
        if(this.settingCShDialog?.bathingScreenConfig){
            const oldValue = this.settingCShDialog.bathingScreenConfig.sortType;
            this.settingCShDialog.bathingScreenConfig.sortType = type;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { sortType: oldValue },
                { sortType: type }
            );
        }
    }

    onChangeTimeRange(time: any){
        if(this.settingCShDialog?.nyuShoDisplayConfig){
            const oldValue = this.settingCShDialog.nyuShoDisplayConfig.timeRangeSelected;
            this.timeRangeSelected = time;
            this.settingCShDialog.nyuShoDisplayConfig.timeRangeSelected = time;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { timeRangeSelected: oldValue },
                { timeRangeSelected: time }
            );
        }
    }

    onChangeMarginToTimes(time: any){
        if(this.settingCShDialog?.nyuShoDisplayConfig){
            const oldValue = this.settingCShDialog.nyuShoDisplayConfig.marginToTimeSelected;
            this.settingCShDialog.nyuShoDisplayConfig.marginToTimeSelected = time;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { marginToTimeSelected: oldValue },
                { marginToTimeSelected: time }
            );
        }
    }

    onChangeGroup(group: any){
        const oldGroupSelected = this.groupSelected;
        this.groupSelected = group;
        let shouldSave = false;
        if(this.settingCShDialog?.bathingScreenConfig){
            this.settingCShDialog.bathingScreenConfig.groupSelectedKey = group;
            shouldSave = true;
        }
        if(this.settingCShDialog?.nyuShoDisplayConfig){
            this.settingCShDialog.nyuShoDisplayConfig.groupSelected = group;
            shouldSave = true;
        }
        if(this.settingCShDialog?.sortConfig){
            this.settingCShDialog.sortConfig.groupSelected = group;
            shouldSave = true;
        }
        if (shouldSave) {
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { groupSelected: oldGroupSelected },
                { groupSelected: group }
            );
        }
    }

    onChangeBathRoom(bathRoom: any){
        const oldBathRoomSelected = this.bathRoomSelected;
        this.bathRoomSelected = bathRoom;
        if(this.settingCShDialog?.bathingScreenConfig){
            this.settingCShDialog.bathingScreenConfig.bathRoomSelectedKey = bathRoom;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { bathRoomSelected: oldBathRoomSelected },
                { bathRoomSelected: bathRoom }
            );
        }
    }

    onChangeHeaderColumns(data: any) {
        const oldHeaders = buildHeaderLogItems(this.currentHeaders);
        this.currentHeaders?.forEach(hdItem => {
            if(hdItem.title == data.title) hdItem.visible = !hdItem.visible;
        });
        if(this.settingCShDialog?.headers){
            if (this.isNyuSho) {
                let snack = this.currentHeaders.find(f => f.field == 'snack');
                let snackMoi = this.currentHeaders.find(f => f.field == 'snack_moisture');
                snack.hasSubHeader = snackMoi.visible;
            }
            this.settingCShDialog.headers = this.currentHeaders;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { headers: oldHeaders },
                { headers: buildHeaderLogItems(this.currentHeaders) }
            );
        }
    }

    onChangeSettingTime(timeChange: any) {
        if(!timeChange) return;
        const oldTimeChangePage = this.timeChangePage;
        this.timeChangePage = parseFloat(timeChange);

        if(this.settingCShDialog){
            this.settingCShDialog.timeChangePage = this.timeChangePage;
            if(this.settingCShDialog.bathingScreenConfig != undefined)
                this.settingCShDialog.bathingScreenConfig.timeChangeGridPageInMs = this.timeChangePage*this.minuteInMs;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { timeChangePage: oldTimeChangePage },
                { timeChangePage: this.timeChangePage }
            );
        }
    }

    onChangeMarqueeSpeed(speedRate: any) {
        if(!speedRate) return;
        this.marqueeSpeedRate = speedRate;
        this.marqueeSpeedService.setSpeedRate(speedRate, Mode.TV);
    }

    onChangeFlashingType(){
        const oldValue = this.isFlashingMoshiokuri;
        this.isFlashingMoshiokuri = !this.isFlashingMoshiokuri;
        if(this.settingCShDialog){
            this.settingCShDialog.isFlashingMoshiokuri = this.isFlashingMoshiokuri;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { isFlashingMoshiokuri: oldValue },
                { isFlashingMoshiokuri: this.isFlashingMoshiokuri }
            );
        }
    }

    async onChangeUnit(event: any) {
        const oldUnitSelected = this.unitSelected;
        const oldGroupSelected = this.groupSelected;
        const oldBathRoomSelected = this.bathRoomSelected;
        this.unitSelected = event;
        this.displayGroups = await this.handleGroupByUnit();

        this.displayBathRooms = await this.handleBathRoomByUnit();

        if (this.settingCShDialog?.nyuShoDisplayConfig)
            this.settingCShDialog.nyuShoDisplayConfig.unitSelected = this.unitSelected;
        if (this.settingCShDialog?.sortConfig)
            this.settingCShDialog.sortConfig.unitSelected = this.unitSelected;
        if (this.settingCShDialog?.bathingScreenConfig)
            this.settingCShDialog.bathingScreenConfig.unitSelectedKey = this.unitSelected;

        const lstGroupsAfterFilter = (this.displayGroups || []).map((x: any) => x.value);

        const filteredGroups = (this.groupSelected || []).filter((g: any) =>
            lstGroupsAfterFilter.includes(g)
        );

        if (filteredGroups.length === 0) {
            this.groupSelected = [];
        } else {
            this.groupSelected = [];
            for (let i = 0; i < filteredGroups.length; i++) {
                this.groupSelected.push(filteredGroups[i]);
            }
        }
        
        const foundBathRoom = this.displayBathRooms.find((x: any) => x.value === this.bathRoomSelected);
        if (!foundBathRoom) {
            this.bathRoomSelected = "";
            this.settingCShDialog.bathingScreenConfig.bathRoomSelectedKey = "";
        }

        if (this.settingCShDialog?.nyuShoDisplayConfig)
            this.settingCShDialog.nyuShoDisplayConfig.groupSelected = this.groupSelected;
        if (this.settingCShDialog?.sortConfig)
            this.settingCShDialog.sortConfig.groupSelected = this.groupSelected;
        if (this.settingCShDialog?.bathingScreenConfig)
            this.settingCShDialog.bathingScreenConfig.groupSelectedKey = this.groupSelected;

        this.saveSessionConfig(this.settingCShDialog);
        this.logSaucerLogUpdate(
            {
                unitSelected: oldUnitSelected,
                groupSelected: oldGroupSelected,
                bathRoomSelected: oldBathRoomSelected
            },
            {
                unitSelected: this.unitSelected,
                groupSelected: this.groupSelected,
                bathRoomSelected: this.bathRoomSelected
            }
        );
    }

    async saveSessionConfig(config:any){
        if (!config) return;
        const storageConfig = this.prepareCommonSettingForStorage(this.prepareSelectedLeftMenuSettingForStorage(config), config);
        CommonHelper.setScreenConfigByOfficeCd(storageConfig, Mode.TV);
        void this.deviceLicensesService.syncSettingConfig();
    }

    onCheckboxClick(type: any){
        if(type == SortType.hidden_overtime_flg) {
            const oldValue = this.settingCShDialog.sortConfig.hidden_overtime_flg;
            this.settingCShDialog.sortConfig.hidden_overtime_flg = !this.settingCShDialog.sortConfig.hidden_overtime_flg;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { hidden_overtime_flg: oldValue },
                { hidden_overtime_flg: this.settingCShDialog.sortConfig.hidden_overtime_flg }
            );
        }
        if(type == SortType.hidden_leave_user) {
            const oldValue = this.settingCShDialog.sortConfig.hidden_leave_user;
            this.settingCShDialog.sortConfig.hidden_leave_user = !this.settingCShDialog.sortConfig.hidden_leave_user;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { hidden_leave_user: oldValue },
                { hidden_leave_user: this.settingCShDialog.sortConfig.hidden_leave_user }
            );
        }
    }

    onSettingViaAlias(alias: number, value: any) {
        if(!value) return;
        const oldValue = this.calcIntervalDisplayValue(alias);
        switch(alias) {
            case 0:
                this.userDBSettings.handOverSetting.currentConfigValue = value;
                break;
            case 1:
                this.userDBSettings.handOverSetting.intervalSetting.currentValue = value*this.minuteInMs;
                break;
            case 2:
                this.userDBSettings.imageIntervalSetting.currentValue = value*this.minuteInMs;
                break;
            case 3:
                this.userDBSettings.carePlanIntervalSetting.currentValue = value*this.minuteInMs;
                break;
        }

        if (this.settingCShDialog.userDashboardSettings) {
            this.settingCShDialog.userDashboardSettings = this.userDBSettings;
            this.saveSessionConfig(this.settingCShDialog);
            this.logSaucerLogUpdate(
                { alias, value: oldValue },
                { alias, value: this.calcIntervalDisplayValue(alias) }
            );
        }
    }

    calcIntervalDisplayValue(alias: number) {
        let value = 0;
        switch(alias) {
            case 0:
                value = this.userDBSettings.handOverSetting.currentConfigValue/this.minuteInMs;
                break;
            case 1:
                value = this.userDBSettings.handOverSetting.intervalSetting.currentValue/this.minuteInMs;
                break;
            case 2:
                value = this.userDBSettings.imageIntervalSetting.currentValue/this.minuteInMs
                break;
            case 3:
                value = this.userDBSettings.carePlanIntervalSetting.currentValue/this.minuteInMs
                break;
        }

        return value
    }

    onInputKeyDown(event: any){}

    onFocusOutInput(event: any){}

    onChangeDeviceName(value: string) {
        this.deviceName = this.limitDeviceName(value);
    }

    async onDeviceNameKeyboardDone(value: string) {
        this.deviceName = this.limitDeviceName(value);
        await this.saveDeviceName(this.deviceName);
    }

    // TV keyboard bypasses maxlength, so cut the name and refresh the input
    private limitDeviceName(value: string): string {
        const deviceName = (value ?? '').substring(0, DEVICE_NAME_MAX_LENGTH);
        if (deviceName !== value) {
            const input = document.getElementById(DEVICE_NAME_INPUT_ID) as HTMLInputElement | null;
            if (input) input.value = deviceName;
            this.syncNativeKeyboardValue(deviceName);
        }
        return deviceName;
    }

    // native keyboard keeps its own text, reset it so the extra chars are dropped
    private syncNativeKeyboardValue(value: string): void {
        const androidBridge = (window as any).AndroidBridge;
        if (typeof androidBridge?.onFocus === 'function') androidBridge.onFocus(false, value, DEVICE_NAME_INPUT_ID);
    }

    async onDeviceNameFocusOut() {
        await this.saveDeviceName(this.deviceName);
    }

    private async saveDeviceName(value: string) {
        const deviceName = value?.trim();
        // nếu k có device name hoặc device name k thay đổi thì k update.
        if (!deviceName || deviceName === this.savedDeviceName || deviceName === this.savingDeviceName) return;
        const deviceId = this.firebaseDeviceInfoService.getAndroidDeviceId();
        if (!deviceId) return;
        this.savingDeviceName = deviceName;
        this.mutiLoadingService.show();
        try {
            await this.deviceLicensesService.updateDeviceNameByDeviceId(deviceId, deviceName);
            this.savedDeviceName = deviceName;
            this.deviceNameChange.emit(deviceName);
        } finally {
            this.savingDeviceName = '';
            this.mutiLoadingService.hide();
        }
    }

    async onReloadWebClick(): Promise<void> {
        // no spinner here: the index.html loading logo covers the reload, and on the TV app the native
        // spinner would not be closed by the reload and would stay over that logo
        await this.clearWebCache();
        // mark to sync the new web version after reload (see TvStartupService)
        this.sessionStorageService.setSessionData(SESSION_STORAGE_KEY.syncVersionAfterReload, true);
        // reload to load the latest web build
        window.location.reload();
    }

    private async clearWebCache(): Promise<void> {
        if (!('caches' in window)) return;
        try {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
        } catch (error) {
            console.error('Clear web cache failed:', error);
        }
    }

    private prepareCommonSettingForStorage(storageConfig: any, config: any): any {
        if (this.isFunctionalTrainingSettingMenu) {
            return {
                ...storageConfig,
                nyuShoDisplayConfig: {
                    ...(storageConfig?.nyuShoDisplayConfig ?? {}),
                    ...this.getCommonNyuShoDisplayConfig(config?.nyuShoDisplayConfig),
                },
            };
        }

        if (this.isShortTimeSettingMenu) {
            return {
                ...storageConfig,
                sortConfig: {
                    ...(storageConfig?.sortConfig ?? {}),
                    ...this.getCommonSortConfig(config?.sortConfig),
                },
            };
        }

        return storageConfig;
    }

    private getCommonNyuShoDisplayConfig(nyuShoDisplayConfig: any): any {
        return {
            ...(nyuShoDisplayConfig?.timeRangeSelected !== undefined ? { timeRangeSelected: nyuShoDisplayConfig.timeRangeSelected } : {}),
            ...(nyuShoDisplayConfig?.marginToTimeSelected !== undefined ? { marginToTimeSelected: nyuShoDisplayConfig.marginToTimeSelected } : {}),
            ...(nyuShoDisplayConfig?.unitSelected !== undefined ? { unitSelected: nyuShoDisplayConfig.unitSelected } : {}),
            ...(nyuShoDisplayConfig?.groupSelected !== undefined ? { groupSelected: nyuShoDisplayConfig.groupSelected } : {}),
        };
    }

    private getCommonSortConfig(sortConfig: any): any {
        return {
            ...(sortConfig?.unitSelected !== undefined ? { unitSelected: sortConfig.unitSelected } : {}),
            ...(sortConfig?.groupSelected !== undefined ? { groupSelected: sortConfig.groupSelected } : {}),
            ...(sortConfig?.hidden_overtime_flg !== undefined ? { hidden_overtime_flg: sortConfig.hidden_overtime_flg } : {}),
            ...(sortConfig?.hidden_leave_user !== undefined ? { hidden_leave_user: sortConfig.hidden_leave_user } : {}),
        };
    }

    // #region Saucer Log
    private getLeftMenuDisplayName(): string {
        switch (this.leftMenuName) {
            case 'checksheet': return this.TV.TV_SETTING_CHECKSHEET;
            case 'checksheet-ft-training': return this.TV.TV_SETTING_CHECKSHEET_FUNCTIONAL_TRAINING;
            case 'checksheet-shorttime': return this.TV.TV_SETTING_CHECKSHEET_SHORT_TIME;
            case 'excreation': return this.TV.TV_SETTING_EXCREATIONS;
            case 'user-dashboard': return this.TV.TV_SETTING_USER;
            case 'bathe': return this.TV.TV_SETTING_BATHE;
            default: return this.leftMenuName;
        }
    }

    private getMidMenuDisplayName(): string {
        switch (this.midMenuId) {
            case UserSettingMenu.TV_CHECKSHEET_DISPLAY_SETTING:
            case UserSettingMenu.TV_EXCREATION_DISPLAY_SETTING:
            case UserSettingMenu.TV_USER_DB_DISPLAY_SETTING:
            case UserSettingMenu.TV_BATHE_DISPLAY_SETTING:
                return this.TV.TV_SETTING_NYUSHO;
            case UserSettingMenu.TV_CHECKSHEET_COLUMN_SETTING:
            case UserSettingMenu.TV_BATHE_COLUMN_SETTING:
                return this.TV.TV_SETTING_COLUMN;
            case UserSettingMenu.TV_CHECKSHEET_CHANGE_PAGE_SETTING:
            case UserSettingMenu.TV_EXCREATION_CHANGE_PAGE_SETTING:
            case UserSettingMenu.TV_BATHE_CHANGE_PAGE_SETTING:
                return this.TV.TV_SETTING_CONFIG;
            case UserSettingMenu.TV_USER_DB_SYSTEM_SETTING:
                return this.TV.TV_USER_DB_CONFIG;
            default:
                return '';
        }
    }

    private logSaucerLogUpdate(oldConfig: any, newConfig: any): void {
        this.saucerLogService.action(
            {
                screenName: `${SCREEN_NAME.SETTING_DIALOG} ＞ ${this.getLeftMenuDisplayName()} ＞ ${this.getMidMenuDisplayName()}`,
                content: JSON.stringify({
                    old: oldConfig,
                    new: newConfig
                })
            },
            { action: SAUCER_LOG_ACTION.SETTING.UPDATE }
        );
    }
    // #endregion Saucer Log
}
